module.exports = __webpack_public_path__ + "media/images/svg/search-11d63dd5683ea68f77282e26eeff51bd.svg";